<div>
    @if (synligeNoter.length) {
        <mat-list>
            @for (noteFormGroup of synligeNoter; track noteFormGroup) {
                <mat-list-item [class.invalid]="noteFormGroup.invalid">
                    <button
                        mat-icon-button
                        (click)="onRedigerClick(noteFormGroup)"
                        [attr.aria-label]="'Rediger note ' + noteFormGroup.value.overskrift"
                        role="button"
                        type="button"
                    >
                        <mat-icon svgIcon="pencil"></mat-icon>
                    </button>
                    <span mat-line>{{ noteFormGroup.value.overskrift }}</span>
                </mat-list-item>
            }
        </mat-list>
    } @else {
        <div class="ingen-noter" [innerHTML]="ingenNoterTekst"></div>
    }

    @if (maxNoter > synligeNoter.length) {
        <div class="button-list">
            <button mat-stroked-button type="button" aria-label="Åben opret ny note dialog" (click)="onOpretClick()" role="button" type="button">NY NOTE</button>
        </div>
    }
</div>
